import {Mapper} from '@s-ui/domain'

export default class FromMarketedVersionsListRawDataToMarketedVersionsListValueObjectMapper extends Mapper {
  constructor({marketedVersionsListValueObject, marketedVersionValueObject}) {
    super()
    this._marketedVersionsListValueObject = marketedVersionsListValueObject
    this._marketedVersionValueObject = marketedVersionValueObject
  }

  _parseDate = date => new Date(date).toLocaleDateString()

  map = ({marketedVersionsList}) => {
    const items = marketedVersionsList.map(({price, url, initDate, endDate}) =>
      this._marketedVersionValueObject({
        price,
        url,
        initDate: this._parseDate(initDate),
        endDate: endDate && this._parseDate(endDate)
      })
    )

    return this._marketedVersionsListValueObject({items})
  }
}
